import axios from 'axios';

export default {
  all(params = {}) {
    return axios.get('/acl/permissions', {params});
  },
  detail(id: string | number, params = {}) {
    return axios.get(`/acl/permissions/${id}`, {params});
  },
  create(payload = {}) {
    return axios.post('/acl/permissions', payload);
  },
  update(id: string | number, payload = {}) {
    return axios.patch(`/acl/permissions/${id}`, payload);
  },
  delete(id: string | number) {
    return axios.delete(`/acl/permissions/${id}`);
  },
};
